import { helper } from '@ember/component/helper';

export const lookup = (params) => params[0][params[1]];

export default helper(lookup);
